<template>
  <div class="GymPopup">
    <div class="mask-container" @click.stop="onClose"></div>
    <div class="pop-cent">
      <img @click="imgClick" class="pop-img" src="https://cdnvue.gymcity.com.cn/uploads/2025-gzhdaka-tc-betterwe">
      <img class="close-img" src="https://cdnvue.gymcity.com.cn/uploads/b9613ad5441024843dc083a522a19d9e.webp" @click.stop="onClose"></img>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReservationsActPop',
  props: {
  },
  data() {
    return {
    }
  },
  created() {},
  methods: {
    onClose() {
      this.$emit('boxClose')
    },
    imgClick(){
      this.$router.push('/activity/spring-festival-course-reservation')
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.GymPopup {
  .mask-container {
    background-color: #000;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.6;
    width: 100%;
    height: 100%;
    z-index: 99;
  }
  .pop-cent {
    width: vw(320);
    position: fixed;
    top: 48%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    color: #000;
    text-align: left;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    .pop-img{
      width: 100%;
    }
    .close-img{
      margin-top: vw(20);
      width: vw(30);
    }
  }
}
</style>
<style lang="scss">
.GymMessageBox {
  .animated {
    animation-duration: 0.5s;
  }
}
</style>
